import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal, {ModalBodyColor} from 'ui-library/modals/Modal';

interface SavedSearchModalLoadingScreenProps {
  closeModal: () => void;
}

export function SavedSearchModalLoadingScreen(props: SavedSearchModalLoadingScreenProps): JSX.Element {
  return (
    <Modal
      onRequestClose={props.closeModal}
      title="Saved Searches"
      mediumLarge={true}
      fullHeight={true}
      modalBodyBgColor={ModalBodyColor.GRAY_LIGHTER}
    >
      <div className={css(styles.body)}>
        <CenteredHorizontalThrobber />
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  body: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '123px',
    marginBottom: '178px',
  },
});
